import { StaticPage } from '@fhs/static-page';

export default StaticPage;

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';
